module.exports = __webpack_public_path__ + "media/images/undraw_dashboard-1d4238a62c66804f51ade340ee518a8e.svg";